// eslint parsing will be thrown here since this is still considered
// experimental for eslint
const getImporter = moduleName => () => import('@/scripts/pages/shared/element-mount-pages/' + moduleName);

const componentRoute = {
  // Components // TODO: These component are not suppose to be in here
  VSBannerDownload: getImporter('vs-banner-download'),
  VSVueGlobalComponents: getImporter('vs-vue-global-components'),
  VSCommunityTopicBar: getImporter('vs-community-topic-bar'),

  VSLayoutRenderer: getImporter('vs-layout-renderer'),

  // Main page
  VSIndex: getImporter('vs-index'),
  VSIndexPre2021: getImporter('vs-index-pre-2021'),
  VSVideo: getImporter('vs-video'),

  // Utilities page
  VSLogout: getImporter('vs-logout'),
  VSError: getImporter('vs-error'),

  // Browse liked page
  VSSearch: getImporter('vs-search'),
  VSBrowse: getImporter('vs-browse'),
  VSTag: getImporter('vs-tag'),
  VSSeries: getImporter('vs-series'),
  VSSeriesList: getImporter('vs-series-list'),

  // Channels
  VSChannels: getImporter('vs-channels'),
  VSChannelEdition: getImporter('vs-channel-edition'),
  VSChannelEditions: getImporter('vs-channel-editions'),
  VSChannelEditionPlaylist: getImporter('vs-channel-edition-playlist'),

  // Profile
  VSProfile: getImporter('vs-profile'),
  VSProfileSettings: {
    default: getImporter('vs-profile-settings'),
    rules: {
      needLogin: true,
    },
  },

  // One pager
  VSJuree: getImporter('vs-juree'),
  VSJureeRenderer: getImporter('vs-juree-renderer'),
  VSByteplus: getImporter('vs-byteplus'),
  VSDeviceClaim: getImporter('vs-device-claim'),
};

export default componentRoute;
